import React, { FunctionComponent } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import HRRService from "../utils/HRRService"
// import HRRCrudService from "../utils/HRRCrudService"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import HRRDownloadReport from "../HRRDownloadReport/HRRDownloadReport"
import HRRCrudService from "../utils/HRRCrudService"
import "./HRRRunReport.css"

const HRRRunReport: FunctionComponent<{}> = () => {

    const { cleanUp, state } = HRRService
    // const { runReport } = HRRCrudService
    const { runReport: runReportNonRecursive } = HRRCrudService
    const { progress, fetchingEmployees, reporting, finished } = state

    const isRunning = fetchingEmployees || reporting || finished

    return (
        <div className="HRRRunReport">
            {state.selectedReport && <Modal
                id="hrr-run-report-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
            >
                <Modal.Header>
                    <div className="HRRRunReportModalHeader">
                        {/*@ts-ignore*/}
                        <p>{state.selectedReport.name}</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="HRRRunReportModalBody">
                        {!isRunning &&
                            <div className="HRRRunReportModalBodyReportInstructions">
                                <div className="HRRRunReportModalBodyReportInstructionsText">
                                    <p>Click <strong>Run</strong> to get your report...</p>
                                </div>
                                <div className="HRRRunReportModalBodyReportInstructionsFluffy">
                                    <span className="material-icons">summarize</span>
                                </div>
                            </div>
                        }
                        {reporting &&
                            <div className="HRRRunReportModalBodyReportProgress">
                                {fetchingEmployees &&
                                    <div className="HRRRunReportModalBodyReportProgressFetchingEmployees">
                                        <div className="HRRRunReportModalBodyReportProgressFetchingEmployeesUpper">
                                            <p>Fetching employees...</p>
                                            <Spinner id="fdfc7026-30b1-4ffc-8bd7-0689636a8e3e" animation="border" />
                                        </div>
                                        <div className="HRRRunReportModalBodyReportProgressFetchingEmployeesLower">
                                            <span className="material-icons">groups</span>
                                        </div>
                                    </div>
                                }
                                {reporting && !fetchingEmployees &&
                                    <div className="HRRRunReportModalBodyReportProgressReporting">
                                        <p>Running report...</p>
                                        <CircularProgressbar
                                            value={progress}
                                            maxValue={100}
                                            text={`${progress}%`}
                                            strokeWidth={4}
                                            styles={buildStyles({
                                                rotation: 0.50,
                                                strokeLinecap: 'butt',
                                                textSize: "20px",
                                                pathTransitionDuration: 0.5,
                                                pathColor: "#007bff",
                                                textColor: "#000000",
                                                trailColor: "FFFFFF",
                                            })}
                                        />
                                    </div>
                                }
                            </div>
                        }
                        {finished &&
                            <div className="HRRRunReportModalBodyReportFinished">
                                <HRRDownloadReport />
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="HRRRunReportModalFooter">
                        <div className="HRRRunReportModalFooterLeft">
                            <Button variant="secondary" onClick={() => cleanUp()}>Quit</Button>
                        </div>
                        <div className="HRRRunReportModalFooterRight">
                            {/* <Button variant="primary" disabled={isRunning} onClick={() => runReport()}>Run</Button> */}
                            <Button variant="primary" disabled={isRunning} onClick={() => runReportNonRecursive()}>Run</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>}
        </div>
    )
}

export default HRRRunReport